// @owners { team: patients-team }
import { COLORS, SPACING } from '@alto/design-library-tokens';
import {
  Button,
  Card,
  Column,
  Description,
  Illustration,
  LgPadding,
  MdPadding,
  MdSpacing,
  Row,
} from '@alto/design-system';
import React, { useEffect } from 'react';
import { Linking } from 'react-native';
import styled from 'styled-components/native';
import FertilityPackageCheckmarkImage from '~shared/assets/images/fertility_package_checkmark.png';
import { IMG_ALT_TEXTS, PROGYNY_UNBOXING_GUIDE_URL } from '~shared/constants';
import { isNative } from '~shared/helpers/isNative';
import { useAnalytics } from '~shared/hooks';
import { EVENTS } from '~shared/lib/analytics/src/constants';

const LeftContent = styled(Column)`
  max-width: 70%;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
`;

export const UnboxingGuideCard = () => {
  const { trackEvent, trackPageView } = useAnalytics();

  const onPressUnboxingGuide = () => {
    trackEvent({ event: EVENTS.UNBOXING_GUIDE_TAPPED });
    Linking.openURL(PROGYNY_UNBOXING_GUIDE_URL);
  };

  useEffect(() => {
    trackPageView({
      event: EVENTS.ALTO_EDU_UNBOXING_GUIDE_HOMESCREEN_VIEWED,
    });
  }, [trackPageView]);

  const unboxingCard = (
    <Card
      style={{ backgroundColor: COLORS.BACKGROUND_COLORS.PINK_LIGHT }}
      title="Prepare for your upcoming order"
    >
      <LgPadding topPadding={SPACING.STATIC.MD}>
        <Row spaceBetween>
          <LeftContent spaceBetween>
            <Description>See helpful information, including unboxing and storage guidance</Description>
            <MdSpacing />
            <Button
              type="primary"
              label="See unboxing guide"
              onPress={onPressUnboxingGuide}
              width="inline"
              small
            />
          </LeftContent>
          <Column>
            <Illustration
              source={FertilityPackageCheckmarkImage}
              size="lg"
              accessibilityLabel={IMG_ALT_TEXTS.fertilityPackageCheckmark}
            />
          </Column>
        </Row>
      </LgPadding>
    </Card>
  );

  return isNative ? (
    <MdPadding
      topPadding={SPACING.STATIC.NONE}
      bottomPadding={SPACING.STATIC.NONE}
    >
      {unboxingCard}
    </MdPadding>
  ) : (
    unboxingCard
  );
};
